import type { HTMLAttributes } from 'react'

export const SECTION_INSPECTOR_FIELD_ID_BY_TYPE: Record<string, string> = {
  Hero: 'title',
  TextBlock: 'text',
  MediaBlock: 'text',
  MediaGallery: 'contentCollection',
  VideoGallery: 'contentCollection',
  ImageGallery: 'imagesCollection',
  MediaEmbed: 'mediaUrl',
}

export function getSectionInspectorFieldId(typeName: string): string | null {
  return SECTION_INSPECTOR_FIELD_ID_BY_TYPE[typeName] ?? null
}

export function buildContentfulInspectorProps(
  entryId: string | null | undefined,
  fieldId: string,
): HTMLAttributes<HTMLElement> {
  if (!entryId || !fieldId) {
    return {}
  }

  return {
    'data-contentful-entry-id': entryId,
    'data-contentful-field-id': fieldId,
  } as HTMLAttributes<HTMLElement>
}
